module.exports = __webpack_public_path__ + "img/be34a4b.png";